import { useRef, useState } from "react";
import { useRouter } from "next/router";

const Search = (props) => {
  const [searchValue, setSearchValue] = useState('');
  const router = useRouter();
  const inputRef = useRef(null);
  const handleSearch = () => {

    if (inputRef.current) {
      inputRef.current.focus();
    }
    if (searchValue.trim()) {
      router.push({
        pathname: '/search-result',
        query: { searchParam: searchValue },
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className={`${"flex justify-end relative "}`}>
      <input
        type="text"
        placeholder="Search"
        ref={inputRef}
        className="w-full searchInput"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button id="searchBtn" className="absolute right-0 top-1/2 -translate-y-1/2  block" onClick={handleSearch}>
        <svg viewBox="72.615 72.615 366.771 366.771">
          <path d="M436.26,421.177l-83.336-83.335c25.578-29.168,39.69-66.072,39.69-105.227c0-42.74-16.646-82.917-46.864-113.136s-70.396-46.864-113.136-46.864s-82.917,16.646-113.136,46.864s-46.864,70.396-46.864,113.136c0,42.739,16.646,82.917,46.864,113.135s70.396,46.865,113.136,46.865c39.154,0,76.06-14.113,105.227-39.691l83.336,83.337c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.541-3.125C440.427,432.094,440.427,425.344,436.26,421.177zM134.563,330.666c-26.188-26.191-40.615-61.016-40.615-98.051c0-37.037,14.428-71.859,40.615-98.052c26.192-26.188,61.016-40.615,98.052-40.615s71.859,14.427,98.052,40.615c26.188,26.193,40.615,61.016,40.615,98.052c0,37.036-14.428,71.86-40.615,98.051c-26.192,26.188-61.016,40.615-98.052,40.615S160.755,356.854,134.563,330.666z" />
        </svg>
      </button>
    </div>
  );
};

export default Search